import { CdkMenuItem } from '@angular/cdk/menu';
import { Component, input, output } from '@angular/core';
import {
  ButtonDirective,
  CuiDropdownComponent,
  CuiDropdownTriggerDirective,
} from '@innersource/common-ui-components';
import { ChatExpert } from '../chat.model';

/** Lets the user choose the expert for the next message. */
@Component({
  selector: 'app-chat-expert-picker',
  imports: [ButtonDirective, CdkMenuItem, CuiDropdownComponent, CuiDropdownTriggerDirective],
  templateUrl: './chat-expert-picker.component.html',
  styleUrl: './chat-expert-picker.component.scss',
})
export class ChatExpertPickerComponent {
  /** Inputs. */
  readonly experts = input.required<ChatExpert[]>();
  readonly selectedExpert = input<ChatExpert | null>(null);

  /** Outputs. */
  readonly selectExpert = output<string>();
}
